import {SourceLinkSettingsModel} from "../../settings/models/source-link-settings";
import {autoinject, Container} from "aurelia-dependency-injection";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import Marionette from "../../shared/marionette-mustache";
import {ThinkerView} from "../../shared/views/thinker";
import { UserSettingsModel } from "../models/user-settings";
import { AppEvents } from "../../app-events";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const template  = require<string>("../../settings/views/source-link-settings.html");
const contentTemplate  = require<string>("../../settings/views/source-link-settings-content.html");

const dom  = {
    SETTINGS_LINK: ".sourcelink-setting-link",
    BACK_LINK: ".sourcelink-back-link",
    CHECKBOXES: ".sourcelink-check",
    OVERRIDE_CHECKBOX: ".sourcelink-check-override",
    LOADING_REGION: "#sourcelink-loading-region",
    CONTENT_REGION: "#sourcelink-content-region",
    SETTING_NAME: ".sourcelink-setting-name",
    SAVE_ORG_SETTINGS: ".save-organisation-sourcelinks-button",
};

@autoinject
@backboneViewProperties({
    template: template
})
export class SourceLinkSettingsView  extends Marionette.LayoutView<SourceLinkSettingsModel> {

    private loadingRegion: Marionette.Region;

    constructor(public model: SourceLinkSettingsModel, public userModel: UserSettingsModel) {
        super();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.SETTINGS_LINK] = (e) => this.linkClick(e);
        events["click " + dom.BACK_LINK] = (e) => this.backClick(e);
        events["click " + dom.CHECKBOXES] = (e) => this.checkboxClick(e);
        events["click " + dom.OVERRIDE_CHECKBOX] = (e) => this.overrideCheckboxClick(e);
        events["click " + dom.SETTING_NAME] = (e) => this.settingNameClick(e);
        events["click " + dom.SAVE_ORG_SETTINGS] = () => this.saveOrganisationSettingsClick();
        return events;
    }

    public regions(): any {
        const regions: any = {
            loadingRegion: dom.LOADING_REGION
        };
        return regions;
    }

    public onShow() {
        this.setupLoader();
    }

    public renderSettings() {
        this.render();
        const data = {
            ChildData: this.model.get("ChildData"),
            IsAdminUser: this.userModel.IsAdminUser,
            HasOverrideFlag: this.model.UserHasOverrideFlag
        };
        if (!this.userModel.IsAdminUser && !this.userModel.IsAuthenticatedByIP) {
            $("#sourcelink-settings").toggleClass("user-override", this.model.CanUsersChangeSettings);
        }
        const partial = contentTemplate;
        const tmpl = "<div class='sourcelink-block'>{{>sourcelink_template}}</div>";
        const html = Mustache.render(tmpl, data, { sourcelink_template: partial });
        this.$(dom.CONTENT_REGION).append(html).show();
        this.$(dom.OVERRIDE_CHECKBOX).prop("checked", this.model.CanUsersChangeSettings);
        this.updateCheckboxes(this.model.id);
    }

    private settingNameClick(e) {
        const $arrow = $(e.currentTarget).parent().parent().find("a");
        if ($arrow.length) {
            e.preventDefault();
            $arrow.trigger("click");
        }
    }

    private setupLoader() {
        this.loadingRegion.show(new ThinkerView());
    }

    private linkClick(e: JQueryEventObject) {
        const level = this.$(e.currentTarget).attr("data-level");
        const id = this.$(e.currentTarget).attr("data-id");
        this.$(e.currentTarget).closest(".sourcelink-block").find(".sourcelink-block").hide();

        const target = this.$(e.currentTarget).closest(".scrollable").siblings(`.sourcelink-block[data-child-id="${id}"]`).show();
        $("#sourcelink-settings").scrollTop(0);
        const title = this.$(e.currentTarget).attr("data-title");

        target.find(".sourcelink-back-link span").first().text(title);
        const offset = (400 * parseInt(level, 10)) + "px";
        const transformString = `transform: translateX(-${offset})`;
        this.$el.parent().attr("style", transformString);
        this.$el.parent().scrollTo(target.find(".sourcelink-back-link").first());
        this.updateCheckboxes(id);
    }

    private checkboxClick(e: JQueryEventObject) {
        $("#settings-thinker").fadeIn();
        const selected = $(e.currentTarget).prop("checked");
        const id = $(e.currentTarget).attr("data-id");
        const parentsOfTarget = [];
        const target = this.searchTreeAndFindParents(this.model, id, parentsOfTarget);
        target.Selected = selected;
        // remove partial checking, as it's absolutely checked in some way or another now
        target.Partial = false;
        // Makes the UI more responsive to the checkbox change
        _.defer(() => {
            this.updateChildren(target, selected);
            this.updateStatesOfParents(parentsOfTarget);
            this.model.save(this.model.attributes, { type: "post" });
            $("#settings-thinker").fadeOut();
        });
    }

    private overrideCheckboxClick(e: JQueryEventObject) {
        const selected = $(e.currentTarget).prop("checked");
        this.$(dom.OVERRIDE_CHECKBOX).prop("checked", selected);
        this.model.CanUsersChangeSettings = selected;
    }

    private updateChildren(target: SourceLinkSettingsModel, selected: boolean) {
        if (target.Children) {
            for (let i = 0; i < target.Children.size(); i++) {
                const child = target.Children.at(i);
                child.Selected = selected;
                // remove any partial checking
                child.Partial = false;
                if (child.Children) {
                    this.updateChildren(child, selected);
                }
            }
        }
    }

    private backClick(e: JQueryEventObject) {
        const level = this.$(e.currentTarget).attr("data-level");
        const levelInt = parseInt(level, 10);
        const offset = (400 * (levelInt - 1)) + "px";
        const transformString = "transform: translateX(-" + offset + ")";
        this.$el.parent().attr("style", transformString);
        // need to find the right parent link to refresh the checkboxes of
        // for finding selecteds / partially selecteds.
        const parentId = this.$(e.currentTarget)
            .parents(".sourcelink-block")
            .first()
            .attr("data-child-id");
        if (parentId) {
            // treverse the tree to find the parent's parent
            // it will be the parent and its siblings displayed on screen now
            // so we need to refresh the grandparent's children
            const parents = [];
            this.searchTreeAndFindParents(this.model, parentId, parents);
            if (parents.length === 0) {
                return;
            }
            const grandparent = _.first(parents);
            // set the checkboxes to be updated from the model
            this.updateCheckboxes(grandparent.Id);
        }
    }

    private updateCheckboxes(parentId: string): void {
        const target = this.searchTree(this.model, parentId);
        const children = target.Children;
        for (let i = 0; i < children.size(); i++) {
            const child = children.at(i);
            const $chk = this.$(dom.CHECKBOXES).filter(`[data-id="${child.Id}"]`);
            $chk.prop("checked", child.Selected);
            $chk.prop("indeterminate", child.Partial && !child.Selected);
        }
    }

    private searchTree(model: SourceLinkSettingsModel, id: string) {
        if (model.Id === id) {
            return model;
        } else if (model.Children !== null) {
            let result = null;
            for (let i = 0; result === null && i < model.Children.size(); i++) {
                result = this.searchTree(model.Children.at(i), id);
            }
            return result;
        }
        return null;
    }

    private searchTreeAndFindParents(model: SourceLinkSettingsModel, id: string, parents: object[]) {
        if (model.Id === id) {
            return model;
        } else if (model.Children !== null) {
            const children = model.Children;
            let result = null;
            for (let i = 0; result === null && i < children.size(); i++) {
                result = this.searchTreeAndFindParents(children.at(i), id, parents);
                if (result) {
                    parents.push(model);
                }
            }
            return result;
        }
        return null;
    }

    private updateStatesOfParents(parents: any[]) {
        _.forEach(parents, (element) => {
            this.recalculateSelectedValueFromChildren(element);
            this.recalculatePartialValueFromChildren(element);
        });
    }

    // have to do this in the view, as doing this with Backbone properly
    // is soooo slow :(
    /** Examines the children of this sourcelink to determine if it's partially selected */
    private recalculatePartialValueFromChildren(model: SourceLinkSettingsModel): void {
        const children = model.Children;
        // if this has got any partial children, we can short circuit and set this
        // to be partial as well
        if (children.any((c) => c.Partial)) {
            model.Partial = true;
            return;
        }
        const selectedCount = children.where({ Selected: true }).length;
        const partial = selectedCount > 0 && selectedCount < children.length;
        model.Partial = partial;
    }

    /** Examines the children of the element to determine if all are selected and therefore whether the parent should be selected */
    private recalculateSelectedValueFromChildren(model: SourceLinkSettingsModel) {
        const children = model.Children;
        if (!children || children.length === 0) {
            return; // probably never going to even get here if it hasn't got children
        }
        const allSelected = children.all((child) => child.Selected);
        model.Selected = allSelected;
    }

    private saveOrganisationSettingsClick(): void {
        $("#settings-thinker").fadeIn();
        this.model.SaveOrganisationSettings = true;
        this.model.save(this.model.attributes, {
            type: "post",
            parse: false,
            success: () => {
                $("#settings-thinker").fadeOut();
                ContainerHelper.Events.trigger(AppEvents.InformationMessage, "Organisation settings saved");
                ContainerHelper.Events.trigger(AppEvents.AppInsightsOrganisationSaved, {Saved: true});
            },
            error: (model, response) => {
                $("#settings-thinker").fadeOut();
                if (response.status === 500) {
                    ContainerHelper.Events.trigger(AppEvents.ErrorMessage, response.responseJSON.Message);
                } else {
                    if (response.status !== 0) {
                        ContainerHelper.Events.trigger(AppEvents.ErrorMessage, "Could not connect to server");
                    }
                }
            }
        });
        this.model.SaveOrganisationSettings = false;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/settings/views/source-link-settings.ts